export const contactNameKey = '_contactName_'
export const leadEventSentAt = '_lESAt'
export const paymentScreenVisitedKey = '_psv'
